import { render, staticRenderFns } from "./CollapseTaskBtn.vue?vue&type=template&id=56b5ab66&"
import script from "./CollapseTaskBtn.vue?vue&type=script&lang=js&"
export * from "./CollapseTaskBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b5ab66')) {
      api.createRecord('56b5ab66', component.options)
    } else {
      api.reload('56b5ab66', component.options)
    }
    module.hot.accept("./CollapseTaskBtn.vue?vue&type=template&id=56b5ab66&", function () {
      api.rerender('56b5ab66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/CollapseTaskBtn.vue"
export default component.exports